var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop"},[_c('div',{staticClass:"uploader"},[_c('div',[_vm._v("Uploading...")]),_c('div',{staticClass:"text-center"},[_c('Loader')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }